<template>
  <div class="search-popup-scroll">
    <div v-for="(keywordGroup, index) in getRealTimeList" :key="index" class="popup-component-wrap">
      <h4 class="component-title">{{getTitle(keywordGroup.type)}}</h4>

      <div v-if="isVodKeywordList(keywordGroup)" class="sh-component01-wrap">
        <div v-for="(keyword, index2) in keywordGroup.list" :key="index2" class="sh-component01">
          <a href="#" @click.prevent="()=>goPlayerPage({name: 'player_vod', query: {programid: keyword.programid}})">
            <!--<span v-if="keyword.image" class="con-img"><img :src="keyword.image | addPostfixAndUrl('90')" alt=""/></span>-->
            <span class="con-text-wrap">
              <strong class="con-tit" v-html="setWordChange(keyword.displaykeywords)"></strong>
            </span>
          </a>
        </div>
      </div><!--sh-component01-list//-->

      <ul v-if="isMovieKeywordList(keywordGroup)" class="sh-pop-list01">
        <li v-for="(keyword, index2) in keywordGroup.list" :key="index2" >
          <a href="#" @click.prevent="()=>goPlayerPage({name: 'player_movie', query:{movieid: keyword.movieid}})"
             v-html="setWordChange(keyword.displaykeywords)"></a>
        </li>
      </ul><!--sh-pop-list01//-->

    </div><!--//-->
  </div><!--popup-scroll//-->
</template>

<script>
import _ from 'lodash'
import { addPostfixAndUrl, setReplaceAll, setDisableScrolling } from '@/common/utils/common'
import { CLOSE_SEARCH_POPUP_EVENT } from '@/common/resources/const'
const VOD_KEYWORD_LIST = 'vodkeywordlist'
const MOVIE_KEYWORD_LIST = 'moviekeywordlist'
const SEARCH_INFO = 'searchinfo'
export default {
  props: {
    searchWord: {
      type: String
    },
    realTimeList: {
      type: Array
    }
  },
  filters: {
    addPostfixAndUrl
  },
  computed: {
    getRealTimeList () {
      const isVodOrMovieKeywordList = keyword => this.isVodKeywordList(keyword) || this.isMovieKeywordList(keyword)
      const hasItem = keyword => Number(_.get(keyword, 'totalcount', '0')) > 0
      return _.filter(this.realTimeList,
        keyword => isVodOrMovieKeywordList(keyword) && !this.isSearchInfo(keyword) && hasItem(keyword))
    }
  },
  methods: {
    isVodKeywordList (keyword) {
      return keyword.type === VOD_KEYWORD_LIST
    },
    isMovieKeywordList (keyword) {
      return keyword.type === MOVIE_KEYWORD_LIST
    },
    isSearchInfo (keyword) {
      return keyword.type === SEARCH_INFO
    },
    getTitle (type) {
      switch (type) {
        case VOD_KEYWORD_LIST:
          return '프로그램'
        case MOVIE_KEYWORD_LIST:
          return '영화'
        default:
          return ''
      }
    },
    setWordChange (content) {
      let changeWord = '<span class="col-vari-blue">' + this.searchWord + '</span>'
      return setReplaceAll(content, this.searchWord, changeWord)
    },
    goPlayerPage (routeParam) {
      this.$events.$emit(CLOSE_SEARCH_POPUP_EVENT)
      this.$router.push(routeParam)
      setDisableScrolling(false)
    }
  }
}
</script>
<style lang="css" src="@/assets/css/search.css"></style>
<style lang="css">
.search-popup-scroll .popup-component-wrap:first-child{
  padding-bottom: 32px;
  margin-bottom: 32px;
}
.search-popup-scroll .popup-component-wrap:last-child{
  margin-bottom: 32px;
}
</style>
